
import { Menu, Button, Modal, Skeleton } from "antd";
import { useState, useContext, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { QuestionCircleFilled } from '@ant-design/icons';
import Logo from "../../assets/images/Logo.png";
export const menuItems = [
  {
    key: "Dashboard",
    path: "/pimptup-admin/dashboard",
    icon: "fas fa-tachometer-alt",
    label: "Dashboard"
  },
  {
    key: "SubAdminSection",
    path: "/pimptup-admin/sub-admin",
    icon: "fas fa-user-cog",
    label: "Sub Admin Manager"
  },
  {
    key: "UserSubMenu",
    label: "User Manager",
    icon: "fas fa-users",
    children: [
      {
        key: "CustomerSection",
        path: "/pimptup-admin/user/customer",
        label: "Customer Manager"
      },
      {
        key: "DealerSection",
        path: "/pimptup-admin/user/dealer",
        label: "Dealer Manager"
      },
      {
        key: "SpecialistSection",
        path: "/pimptup-admin/user/specialist",
        label: "Specialist Manager"
      }
    ]
  },
  {
    key: "VehicleSubMenu",
    label: "Vehicle Manager",
    icon: "fa fa-car",
    children: [
      {
        key: "TypeSection",
        path: "/pimptup-admin/vehicle/type",
        label: "Type Manager"
      },
      {
        key: "MakeSection",
        path: "/pimptup-admin/vehicle/make",
        label: "Make Manager"
      },
      {
        key: "ModelSection",
        path: "/pimptup-admin/vehicle/model",
        label: "Model Manager"
      },
      {
        key: "VariantSection",
        path: "/pimptup-admin/vehicle/variant",
        label: "Variant Manager"
      }
    ]
  },
  {
    key: "CategorySubMenu",
    label: "Category Manager",
    icon: "fab fa-servicestack",
    children: [
      {
        key: "ServiceCategorySection",
        path: "/pimptup-admin/category/service",
        label: "Service Category"
      },
      {
        key: "ProductCategorySection",
        path: "/pimptup-admin/category/product",
        label: "Product Category"
      }
    ]
  },
  /* {
    key: "BrandSection",
    path: "/pimptup-admin/brand",
    icon: "fas fa-copyright",
    label: "Brand Manager"
  }, */
  {
    key: "ProductSubMenu",
    label: "Product Manager",
    icon: "fab fa-product-hunt",
    children: [
      {
        key: "AttributeSection",
        path: "/pimptup-admin/product/attribute",
        label: "Attribute Manager"
      },
      {
        key: "CatalogueSection",
        path: "/pimptup-admin/product/catalogue",
        label: "Catalogue Manager"
      }
    ]
  },
  {
    key: "ServiceSection",
    path: "/pimptup-admin/service",
    icon: "fas fa-vector-square",
    label: "Service Manager"
  },
  {
    key: "ChatSection",
    path: "/pimptup-admin/chat",
    icon: "fas fa-comments",
    label: "Message/Chat"
  },
  {
    key: "QuotesSection",
    path: "/pimptup-admin/quote",
    icon: "fas fa-question-circle",
    label: "Quotes Manager"
  },
  {
    key: "BlogSection",
    path: "/pimptup-admin/blog",
    icon: "fas fa-splotch",
    label: "Blog Manager"
  },
  {
    key: "BannerSection",
    path: "/pimptup-admin/banner",
    icon: "fas fa-image",
    label: "Banner Manager"
  },
  {
    key: "ContentSection",
    path: "/pimptup-admin/content",
    icon: "fa fa-file",
    label: "Content Manager"
  },
  {
    key: "NotificationSection",
    path: "/pimptup-admin/notification",
    icon: "fa fa-bell",
    label: "Notification Manager"
  },
  {
    key: "EmailSection",
    path: "/pimptup-admin/email-template",
    icon: "fas fa-envelope",
    label: "Email Template Manager"
  },
  {
    key: "Setting",
    path: "/pimptup-admin/setting",
    icon: "fas fa-cog",
    label: "Setting Manager"
  },
]


function Sidenav({ color }) {

  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  const { userProfile, logout, setUserProfile } = useContext(AuthContext)
  const { confirm } = Modal;
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [menuLinks, setMenuLinks] = useState([]);
  const [menuMode, setMenuMode] = useState('vertical');

  const showDeleteConfirm = (record) => {
    setTimeout(() => {
      confirm({
        okText: 'Logout',
        okType: 'danger',
        icon: <QuestionCircleFilled />,
        cancelText: 'Cancel',
        content: <Button >Are you sure you want to logout ?</Button>,
        onOk() {
          logout();
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    }, 5);
  };

  const isActiveLink = (pattern, pathname) => {
    const regexPattern = new RegExp(`^${pattern.replace('*', '.*')}$`);
    return regexPattern.test(pathname);
  };

  const isVehicleDropdownOpen = isActiveLink('/vehicle/*', pathname);
  const isProductDropdownOpen = isActiveLink('/product/*', pathname);
  const isCategoryDropdownOpen = isActiveLink('/category/*', pathname);
  const isUserDropdownOpen = isActiveLink('/user/*', pathname);

  const renderTitle = (item) => {
    return (
      <>
        <span className="icon"><i className={item.icon}></i></span>
        <span className="label">{item.label}</span>
      </>
    )
  }

  useEffect(() => {
    setLoading(true)
    if (!userProfile) return
    if (userProfile.type == 'Admin') {
      setMenuLinks(menuItems)
      setLoading(false)
      return
    }
    const newArray = menuItems.filter(item => {
      if (item.children) {
        item.children = item.children.filter(child => userProfile.permission?.hasOwnProperty(child.key));
      } else {
        return userProfile.permission?.hasOwnProperty(item.key)
      }
      return item
    });

    const links = newArray.filter(item => {
      if (item?.children?.length) {
        return true
      } else if (!item?.children) {
        return true
      } else {
        return false
      }

    })

    setMenuLinks(links)
    setLoading(false)

  }, [userProfile])

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setMenuMode('inline');
      } else {
        setMenuMode('vertical');
      }
    }

    window.addEventListener('resize', handleResize);

    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      {/* <div className="brand w-100">
        <NavLink to="" className="imgOuter">
          <img className="" src={Logo} alt="" />
        </NavLink>
      </div> */}
      {
        loading ? [1, 2, 3, 4, 5, 6].map(item => <Skeleton active key={item} />)
          :
          <Menu inlineCollapsed={false} mode={menuMode} className="sideNavMain">
            {menuLinks.map(item => {
              if (item.children) {
                return (
                  <Menu.SubMenu key={item.key} title={<>
                    <span className="icon"><i className={item.icon}></i></span>
                    <span className="label">{item.label}</span>
                  </>}>
                    {item.children.map(child => (
                      <Menu.Item key={child.key}>
                        <NavLink to={child.path}>{child.label}</NavLink>
                      </Menu.Item>
                    ))}
                  </Menu.SubMenu>
                );
              }

              return (
                <Menu.Item key={item.key}>
                  <NavLink to={item.path}>
                    {renderTitle(item)}
                  </NavLink>
                </Menu.Item>
              );
            })}


            <Menu.Item onClick={showDeleteConfirm}>
              <NavLink to={'/pimptup-admin/'}>
                <>
                  <span className="icon"><i className="fas fa-sign-out-alt"></i></span>
                  <span className="label">Logout</span>
                </>
              </NavLink>
            </Menu.Item>

          </Menu>
      }

    </>
  );

}

export default Sidenav;
